export default {
  h1_edu: "دورات تعليمية للأطباء المتخصصين في التشخيص",
  Lessons: {
    Lesson: {
      title: "الدرس",
      Files: "المرفقات",
      DownloadAll: "تحميل الكل",
    },
    status: {
      success: "تم اجتيازه",
      unsuccess: "لم يتم اجتيازه",
      stop: "غير متاح",
    },
  },
};
